import React, { useState } from 'react';
import { Button, Popconfirm, message } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { logInstance } from '../../AxiosConfig';

const EditLogoutButton = ({ cardId, style = {} }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setLoading(true);
      const sessionId = searchParams.get('session');

      if (!sessionId) {
        message.error('Session ID not found');
        navigate(`../${cardId}`, { relative: 'path' });
        return;
      }

      await logInstance.post('/card/edit-logout', {
        sessionId
      });

      message.success('Logged out successfully');
      navigate(`../${cardId}`, { relative: 'path' });
    } catch (error) {
      console.error('Logout error:', error);
      message.error(error?.response?.data?.message || 'Failed to logout');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popconfirm
      title="Logout from Edit?"
      description="This will expire the edit link for everyone who has it."
      onConfirm={handleLogout}
      okText="Yes, Logout"
      cancelText="Cancel"
      okButtonProps={{ danger: true }}
    >
      <Button
        danger
        icon={<LogoutOutlined />}
        loading={loading}
        style={style}
      >
        Logout
      </Button>
    </Popconfirm>
  );
};

export default EditLogoutButton;
